import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/tailwind.css'
import { createPinia } from 'pinia'
import { i18n } from './i18n'



createApp(App)
.use(createPinia ())
.use(router)
.use(i18n)

.mount('#app')
